import { CareOrderManagementWrapper } from '../../../../containers/Blotters/CareOrders/CareOrderManagementBlotter/CareOrderManagementWrapper';
import type { CareOrderManagementPanelConfig } from '../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { BlotterPanel } from './blotters/BlotterPanel';

export function CareOrderManagementPanel({ api, params }: LayoutPanelProps<CareOrderManagementPanelConfig>) {
  return (
    <BlotterPanel
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="care-order-management-panel"
      background="backgroundBody"
    >
      <CareOrderManagementWrapper panelId={api.id} />
    </BlotterPanel>
  );
}
